import React, { useEffect } from "react";
import Modal from "react-modal";
import { CancelIcon, CautionIcon, Container, ContentContainer } from "./DeleteConfirmationModal.styles";
import UI from "@mile-meeting/mile-ui";
import { DeleteConfirmationModalProps } from "./types";

const modalStyle = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    border: "none",
    background: "transparent",
    transform: "translate(-50%, -50%)",
  },
  overlay: {
    backgroundColor: "var(--component-color-material-dimmer)",
    zIndex: 1000,
  },
};
Modal.setAppElement("#root");

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  modalIsOpen = false,
  closeModal,
  onDelete,
  meetingRoomName,
  isBlockedMeetingRoom = false,
}) => {
  const [meetingName, setMeetingName] = React.useState("");

  useEffect(() => {
    if (modalIsOpen) setMeetingName("");
  }, [modalIsOpen]);

  const enabledBtn = meetingName === meetingRoomName;

  const handleDelete = () => {
    if (enabledBtn) onDelete?.();
  };

  return (
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={modalStyle}>
      <Container>
        <CancelIcon>
          <UI.IconButton.Normal
            type="primary"
            icon="x"
            size={20}
            color="var(--alias-color-label-normal)"
            onClick={closeModal}
          />
        </CancelIcon>
        <CautionIcon>
          <UI.Icon name="inform" size={56} color="var(--alias-color-status-negative)" />
        </CautionIcon>
        <ContentContainer>
          <UI.Typography type="heading01" fontStyle="bold" color="var(--alias-color-label-normal)">
            "{meetingRoomName}" 회의실을 삭제하시겠습니까?
          </UI.Typography>
          <UI.Typography type="body01 normal" fontStyle="medium" color="var(--alias-color-label-alternative)">
            입력창에 삭제하려는 회의실명을 입력해 주세요.
            <br />
            <span
              style={{
                color: "var(--alias-color-status-negative)",
              }}
            >
              *모든 데이터가 삭제되며, 복구가 불가능합니다.
            </span>
          </UI.Typography>
          {isBlockedMeetingRoom && (
            <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-alternative)">
              이용 가능한 회의실을 삭제할 경우, 다음 우선순위의
              <br />
              이용 제한 회의실이 이용 가능 상태로 변경됩니다.
              <br />* 우선순위 기준: 1) 태블릿 사용, 2) 구글 연동, 3) 가나다순
            </UI.Typography>
          )}

          <UI.Input placeholder={meetingRoomName} value={meetingName} onChange={setMeetingName} />
        </ContentContainer>
        <UI.Button
          type="outlined"
          title="삭제하기"
          size="large"
          disabled={!enabledBtn}
          primary={true}
          style={{ marginTop: "40px", width: "100%" }}
          onClick={handleDelete}
        />
      </Container>
    </Modal>
  );
};

export default React.memo(DeleteConfirmationModal);
